import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { CategoryData } from '../report-admin/report-admin.interfaces';
import { CategoryEvent } from './category-edit-repeater.interfaces';
import { SmartModalService, SmartTable } from '@certemy/ui-components';
import ColumnTypeId = SmartTable.ColumnTypeId;
import { ComputedFrom } from '@certemy/common';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'cm-category-edit-repeater',
  templateUrl: './category-edit-repeater.component.html',
  styleUrls: ['./category-edit-repeater.component.scss'],
})
export class CategoryEditRepeaterComponent implements OnChanges {
  @ComputedFrom('longDescriptionTemplate')
  get previewHeader(): SmartTable.Header {
    return {
      name: 'Long Text',
      propertyName: 'longDescription',
      value: this.longDescriptionTemplate,
      type: SmartTable.ColumnTypeId.TEMPLATE,
    };
  }

  @ComputedFrom('longDescriptionTemplate', 'disableEdit')
  get tableHeaders(): SmartTable.Header[] {
    const defaultHeader = [
      { name: 'Category Name', value: 'category', type: SmartTable.ColumnTypeId.STRING },
      { name: 'Short Text', value: 'shortDescription', type: SmartTable.ColumnTypeId.STRING },
      this.previewHeader,
    ];
    if (!this.disableEdit) {
      defaultHeader.push({
        name: '',
        value: [{ type: 'EDIT', name: 'Edit' }, { type: 'DELETE', name: 'Delete' }],
        type: ColumnTypeId.ACTIONS,
      });
    }
    return defaultHeader;
  }

  constructor(private smartModalService: SmartModalService) {}

  _categories: CategoryData[] = [];

  @Input() categories: CategoryData[];
  @Input() disableEdit: boolean;
  @Input() source: string;
  @Input() data: { status: string; data: CategoryData; id?: number };
  @Output() onInsertClick: EventEmitter<CategoryEvent> = new EventEmitter();
  @Output() onEditClick: EventEmitter<CategoryEvent> = new EventEmitter();
  @Output() onDeleteClick: EventEmitter<CategoryEvent> = new EventEmitter();

  @ViewChild('longDescriptionTemplate', { static: true }) private longDescriptionTemplate: TemplateRef<any> = null;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.categories && changes.categories.previousValue !== changes.categories.currentValue) {
      this._categories = [...this.categories].map((item, index) => ({ ...item, id: index }));
    }
    if (changes.data && changes.data.currentValue) {
      if (this.data.status === 'new') {
        this._categories = [...this._categories, this.data.data].map((item, index) => ({ ...item, id: index }));
      }
      if (this.data.status === 'change') {
        this._categories = this._categories.map((item, i) => (i === this.data.id ? this.data.data : item));
      }
    }
  }

  onCellAction({ payload: { action }, row }) {
    if (action.type === 'EDIT') {
      this.onEditClick.emit({ index: row.id, source: this.source, currentItem: this._categories[row.id] });
    }
    if (action.type === 'DELETE') {
      this.smartModalService
        .openConfirm({
          title: 'Confirm your action',
          body: 'Are you sure you would like to delete this record?',
        })
        .pipe(
          take(1),
          filter(data => !!data),
        )
        .subscribe(() => {
          this._categories = this._categories
            .filter((item, i) => i !== row.id)
            .map((item, index) => ({ ...item, id: index }));
          this.onDeleteClick.emit({ index: row.id, source: this.source });
        });
    }
  }

  createCategory() {
    this.onInsertClick.emit({ index: -1, source: this.source });
  }
}
